// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as NewReleasesComponent} from './NewReleases.svg';

import Icon, { TIconProps } from '../Icon';

export const IconNewReleases = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <NewReleasesComponent/>
  </Icon>
));
